import React from 'react';
const AVA_STYLE = `
/* — BG Circle — */
@keyframes ava_bg_t {
  0%     { transform: translateX(1px) translateY(1px) translate(32px,32px) scaleX(1)    scaleY(1)    translate(-32px,-32px); }
  42.86% { transform: translateX(1px) translateY(1px) translate(32px,32px) scaleX(1.08) scaleY(1.08) translate(-32px,-32px); }
  85.71% { transform: translateX(1px) translateY(1px) translate(32px,32px) scaleX(1)    scaleY(1)    translate(-32px,-32px); }
  100%   { transform: translateX(1px) translateY(1px) translate(32px,32px) scaleX(1)    scaleY(1)    translate(-32px,-32px); }
}
@keyframes ava_bg_o {
  0%     { opacity: 0.7; }
  42.86% { opacity: 1;   }
  85.71% { opacity: 0.7; }
  100%   { opacity: 0.7; }
}
#ava_bg { transform-origin:0 0; animation: ava_bg_t 2.8s cubic-bezier(0.4,0,0.2,1) infinite, ava_bg_o 2.8s cubic-bezier(0.4,0,0.2,1) infinite; }

/* — Ripple 3 — */
@keyframes ava_r3_t {
  0%     { transform: translateX(1px) translateY(1px) translate(32px,32px) scaleX(0.6) scaleY(0.6) translate(-32px,-32px); }
  28.57% { transform: translateX(1px) translateY(1px) translate(32px,32px) scaleX(0.6) scaleY(0.6) translate(-32px,-32px); }
  64.29% { transform: translateX(1px) translateY(1px) translate(32px,32px) scaleX(1.2) scaleY(1.2) translate(-32px,-32px); }
  100%   { transform: translateX(1px) translateY(1px) translate(32px,32px) scaleX(0.6) scaleY(0.6) translate(-32px,-32px); }
}
@keyframes ava_r3_o {
  0%     { opacity: 0.3; } 28.57% { opacity: 0.3; }
  53.57% { opacity: 0.8; } 78.57% { opacity: 0.2; } 100% { opacity: 0.3; }
}
#ava_r3 { transform-origin:0 0; animation: ava_r3_t 2.8s linear infinite, ava_r3_o 2.8s linear infinite; }

/* — Ripple 2 — */
@keyframes ava_r2_t {
  0%     { transform: translateX(6px) translateY(6px) translate(27px,27px) scaleX(0.6) scaleY(0.6) translate(-27px,-27px); }
  14.29% { transform: translateX(6px) translateY(6px) translate(27px,27px) scaleX(0.6) scaleY(0.6) translate(-27px,-27px); }
  50%    { transform: translateX(6px) translateY(6px) translate(27px,27px) scaleX(1.2) scaleY(1.2) translate(-27px,-27px); }
  85.71% { transform: translateX(6px) translateY(6px) translate(27px,27px) scaleX(0.6) scaleY(0.6) translate(-27px,-27px); }
  100%   { transform: translateX(6px) translateY(6px) translate(27px,27px) scaleX(0.6) scaleY(0.6) translate(-27px,-27px); }
}
@keyframes ava_r2_o {
  0%     { opacity: 0.3; } 14.29% { opacity: 0.3; }
  39.29% { opacity: 0.8; } 64.29% { opacity: 0.2; }
  85.71% { opacity: 0.3; } 100%   { opacity: 0.3; }
}
#ava_r2 { transform-origin:0 0; animation: ava_r2_t 2.8s linear infinite, ava_r2_o 2.8s linear infinite; }

/* — Ripple 1 — */
@keyframes ava_r1_t {
  0%     { transform: translateX(11px) translateY(11px) translate(22px,22px) scaleX(0.6) scaleY(0.6) translate(-22px,-22px); }
  35.71% { transform: translateX(11px) translateY(11px) translate(22px,22px) scaleX(1.2) scaleY(1.2) translate(-22px,-22px); }
  71.43% { transform: translateX(11px) translateY(11px) translate(22px,22px) scaleX(0.6) scaleY(0.6) translate(-22px,-22px); }
  100%   { transform: translateX(11px) translateY(11px) translate(22px,22px) scaleX(0.6) scaleY(0.6) translate(-22px,-22px); }
}
@keyframes ava_r1_o {
  0%     { opacity: 0.3; } 25%    { opacity: 0.8; }
  50%    { opacity: 0.2; } 71.43% { opacity: 0.3; } 100% { opacity: 0.3; }
}
#ava_r1 { transform-origin:0 0; animation: ava_r1_t 2.8s linear infinite, ava_r1_o 2.8s linear infinite; }

/* — Star 1 — own svg tx=0, ty=7.685 | half=8.516,8.516 */
@keyframes ava_s1_t {
  0%     { transform: translateX(0px) translateY(7.685px) translate(8.516px,8.516px) rotate(0rad)     scaleX(1)    scaleY(1)    translate(-8.516px,-8.516px); }
  8.57%  { transform: translateX(0px) translateY(7.685px) translate(8.516px,8.516px) rotate(-0.051rad) scaleX(0.7)  scaleY(0.7)  translate(-8.516px,-8.516px); }
  22.86% { transform: translateX(0px) translateY(7.685px) translate(8.516px,8.516px) rotate(-0.137rad) scaleX(1.15) scaleY(1.15) translate(-8.516px,-8.516px); }
  37.14% { transform: translateX(0px) translateY(7.685px) translate(8.516px,8.516px) rotate(-0.089rad) scaleX(0.85) scaleY(0.85) translate(-8.516px,-8.516px); }
  57.14% { transform: translateX(0px) translateY(7.685px) translate(8.516px,8.516px) rotate(0rad)     scaleX(1)    scaleY(1)    translate(-8.516px,-8.516px); }
  100%   { transform: translateX(0px) translateY(7.685px) translate(8.516px,8.516px) rotate(0rad)     scaleX(1)    scaleY(1)    translate(-8.516px,-8.516px); }
}
@keyframes ava_s1_o {
  0%     { opacity: 1;   }
  5.71%  { opacity: 0.4; }
  20%    { opacity: 1;   }
  34.29% { opacity: 0.6; }
  57.14% { opacity: 1;   }
  100%   { opacity: 1;   }
}
#ava_s1 { transform-origin:0 0; animation: ava_s1_t 2.8s cubic-bezier(0.4,0,0.2,1) infinite, ava_s1_o 2.8s cubic-bezier(0.4,0,0.2,1) infinite; }

/* — Star 2 — own svg tx=13.647, ty=0 | half=4.258,4.258 */
@keyframes ava_s2_t {
  0%     { transform: translateX(13.647px) translateY(0px) translate(4.258px,4.258px) rotate(0rad)     scaleX(1)    scaleY(1)    translate(-4.258px,-4.258px); }
  14.29% { transform: translateX(13.647px) translateY(0px) translate(4.258px,4.258px) rotate(0rad)     scaleX(1)    scaleY(1)    translate(-4.258px,-4.258px); }
  22.14% { transform: translateX(13.647px) translateY(0px) translate(4.258px,4.258px) rotate(-0.051rad) scaleX(0.7)  scaleY(0.7)  translate(-4.258px,-4.258px); }
  37.14% { transform: translateX(13.647px) translateY(0px) translate(4.258px,4.258px) rotate(-0.137rad) scaleX(1.15) scaleY(1.15) translate(-4.258px,-4.258px); }
  51.43% { transform: translateX(13.647px) translateY(0px) translate(4.258px,4.258px) rotate(-0.089rad) scaleX(0.85) scaleY(0.85) translate(-4.258px,-4.258px); }
  71.43% { transform: translateX(13.647px) translateY(0px) translate(4.258px,4.258px) rotate(0rad)     scaleX(1)    scaleY(1)    translate(-4.258px,-4.258px); }
  100%   { transform: translateX(13.647px) translateY(0px) translate(4.258px,4.258px) rotate(0rad)     scaleX(1)    scaleY(1)    translate(-4.258px,-4.258px); }
}
@keyframes ava_s2_o {
  0%     { opacity: 1;   }
  14.29% { opacity: 1;   }
  20%    { opacity: 0.4; }
  34.29% { opacity: 1;   }
  48.57% { opacity: 0.6; }
  71.43% { opacity: 1;   }
  100%   { opacity: 1;   }
}
#ava_s2 { transform-origin:0 0; animation: ava_s2_t 2.8s cubic-bezier(0.4,0,0.2,1) infinite, ava_s2_o 2.8s cubic-bezier(0.4,0,0.2,1) infinite; }

/* — Star 3 — own svg tx=16.997, ty=16.996 | half=5.677,5.677 */
@keyframes ava_s3_t {
  0%     { transform: translateX(16.997px) translateY(16.996px) translate(5.677px,5.677px) rotate(0rad)     scaleX(1)    scaleY(1)    translate(-5.677px,-5.677px); }
  21.43% { transform: translateX(16.997px) translateY(16.996px) translate(5.677px,5.677px) rotate(0rad)     scaleX(1)    scaleY(1)    translate(-5.677px,-5.677px); }
  29.29% { transform: translateX(16.997px) translateY(16.996px) translate(5.677px,5.677px) rotate(-0.051rad) scaleX(0.7)  scaleY(0.7)  translate(-5.677px,-5.677px); }
  46.43% { transform: translateX(16.997px) translateY(16.996px) translate(5.677px,5.677px) rotate(-0.14rad)  scaleX(1.15) scaleY(1.15) translate(-5.677px,-5.677px); }
  53.93% { transform: translateX(16.997px) translateY(16.996px) translate(5.677px,5.677px) rotate(-0.089rad) scaleX(0.85) scaleY(0.85) translate(-5.677px,-5.677px); }
  71.43% { transform: translateX(16.997px) translateY(16.996px) translate(5.677px,5.677px) rotate(0rad)     scaleX(1)    scaleY(1)    translate(-5.677px,-5.677px); }
  100%   { transform: translateX(16.997px) translateY(16.996px) translate(5.677px,5.677px) rotate(0rad)     scaleX(1)    scaleY(1)    translate(-5.677px,-5.677px); }
}
@keyframes ava_s3_o {
  0%     { opacity: 1;   }
  21.43% { opacity: 1;   }
  26.43% { opacity: 0.4; }
  38.93% { opacity: 1;   }
  51.43% { opacity: 0.6; }
  71.43% { opacity: 1;   }
  100%   { opacity: 1;   }
}
#ava_s3 { transform-origin:0 0; animation: ava_s3_t 2.8s cubic-bezier(0.4,0,0.2,1) infinite, ava_s3_o 2.8s cubic-bezier(0.4,0,0.2,1) infinite; }
`;
const AvaShieldIcon = () => (React.createElement("svg", { width: "74", height: "74", viewBox: "0 0 82 82", fill: "none", xmlns: "http://www.w3.org/2000/svg", style: { overflow: 'visible' } },
    React.createElement("defs", null,
        React.createElement("filter", { id: "ava_f", x: "-0.25", y: "-0.25", width: "82", height: "82", filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB" },
            React.createElement("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }),
            React.createElement("feColorMatrix", { in: "SourceAlpha", type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }),
            React.createElement("feOffset", { dy: "2" }),
            React.createElement("feGaussianBlur", { stdDeviation: "4" }),
            React.createElement("feComposite", { in2: "hardAlpha", operator: "out" }),
            React.createElement("feColorMatrix", { type: "matrix", values: "0 0 0 0 0.0666667 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.08 0" }),
            React.createElement("feBlend", { mode: "normal", in2: "BackgroundImageFix", result: "ava-shadow-blend" }),
            React.createElement("feBlend", { mode: "normal", in: "SourceGraphic", in2: "ava-shadow-blend", result: "shape" })),
        React.createElement("radialGradient", { id: "ava_rbg", cx: "0", cy: "0", r: "1", gradientUnits: "userSpaceOnUse", gradientTransform: "translate(32 32) scale(32)" },
            React.createElement("stop", { stopColor: "#BFBFBF", stopOpacity: "0.15" }),
            React.createElement("stop", { offset: "0.7", stopColor: "#D9D9D9", stopOpacity: "0.08" }),
            React.createElement("stop", { offset: "1", stopColor: "#E6E6E6", stopOpacity: "0" })),
        React.createElement("linearGradient", { id: "ava_g1", x1: "8.516", y1: "0", x2: "8.516", y2: "17.031", gradientUnits: "userSpaceOnUse" },
            React.createElement("stop", { stopColor: "#42C0FF" }),
            React.createElement("stop", { offset: "1", stopColor: "#B993FF" })),
        React.createElement("linearGradient", { id: "ava_g2", x1: "4.258", y1: "0", x2: "4.258", y2: "8.516", gradientUnits: "userSpaceOnUse" },
            React.createElement("stop", { stopColor: "#42C0FF" }),
            React.createElement("stop", { offset: "1", stopColor: "#B993FF" })),
        React.createElement("linearGradient", { id: "ava_g3", x1: "5.677", y1: "0", x2: "5.677", y2: "11.354", gradientUnits: "userSpaceOnUse" },
            React.createElement("stop", { stopColor: "#42C0FF" }),
            React.createElement("stop", { offset: "1", stopColor: "#B993FF" })),
        React.createElement("style", null, AVA_STYLE)),
    React.createElement("g", { filter: "url(#ava_f)" },
        React.createElement("circle", { id: "ava_bg", cx: "32", cy: "32", r: "32", fill: "url(#ava_rbg)" }),
        React.createElement("circle", { id: "ava_r3", cx: "32", cy: "32", r: "32", stroke: "#E0E0E0", strokeWidth: "1.5", fill: "none" }),
        React.createElement("circle", { id: "ava_r2", cx: "27", cy: "27", r: "27", stroke: "#CCCCCC", strokeWidth: "1.5", fill: "none" }),
        React.createElement("circle", { id: "ava_r1", cx: "22", cy: "22", r: "22", stroke: "#B3B3B3", strokeWidth: "1.5", fill: "none" }),
        React.createElement("circle", { cx: "27", cy: "27", r: "26.5", fill: "#20285C", stroke: "#BED4E8", transform: "translate(6 6)" }),
        React.createElement("g", { transform: "translate(18.8252 18.8249)" },
            React.createElement("path", { id: "ava_s1", d: "M8.51562 0L10.8156 6.21563L17.0312 8.51562L10.8156 10.8156L8.51562 17.0312L6.21563 10.8156L0 8.51562L6.21563 6.21563L8.51562 0Z", fill: "url(#ava_g1)" }),
            React.createElement("path", { id: "ava_s2", d: "M4.25781 0L5.40781 3.10781L8.51562 4.25781L5.40781 5.40781L4.25781 8.51562L3.10782 5.40781L0 4.25781L3.10782 3.10781L4.25781 0Z", fill: "url(#ava_g2)" }),
            React.createElement("path", { id: "ava_s3", d: "M5.67708 0L7.21041 4.14375L11.3542 5.67708L7.21041 7.21041L5.67708 11.3542L4.14375 7.21041L0 5.67708L4.14375 4.14375L5.67708 0Z", fill: "url(#ava_g3)" })))));
export default AvaShieldIcon;
